<template>
  <div class="container-fluid question-page">
    <div class="question-list">
      <div class="function-title">系統說明</div>
      <div class="function-info">
        <div class="info">
          <div class="info-title">系統管理</div>
          <div class="info-desc">設定使用者相關權限，安全控管系統</div>
        </div>
        <div class="info">
          <div class="info-title">招募管理</div>
          <div class="info-desc">
            包含履歷分派、推薦、安排面談、感謝函、預聘、雇用等管理流程。
          </div>
        </div>
        <div class="info">
          <div class="info-title">招聘進度</div>
          <div class="info-desc">
            透過搜尋功能，可迅速查找應徵者資料，並可註記或加入最愛清單。
          </div>
        </div>
        <div class="info">
          <div class="info-title">人才庫</div>
          <div class="info-desc">
            資通電腦線上招募系統可與各人力銀行平台介接 完整建立企業人才資料庫。
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {};
</script>

<style lang="scss" scoped>
.question-page {
  padding: 30px;
  .function-info {
    .info {
      background-color: #fff;
      padding: 20px;
      border-radius: 5px;
      margin-bottom: 5px;
      border: 1px solid #ebebeb;
      box-shadow: -2px 3px 5px rgba(0, 0, 0, 0.1);

      .info-desc {
        font-size: 0.9em;
        line-height: 175%;
      }
    }
  }
}
</style>
